import React, { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';

import { useFlowContext } from '#/providers/FlowContext';

import { NodeDetailsForm } from './Nodes/NodeDetailsForm';

export default function NodeDetailsModal() {
  const {
    setCanDeleteNode,
    selectedNodeData,
    updateWorkflowNodeData,
    setIsNodeDetailsShown,
  } = useFlowContext();

  const handleClose = () => {
    setCanDeleteNode(true);
    setIsNodeDetailsShown(false);
  };

  const handleClickOutside = (e) => {
    if (e.target.id === 'modal-container') {
      handleClose();
    }
  };

  const handleEscapePress = (e) => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleEscapePress);

    return () => {
      document.removeEventListener('keydown', handleEscapePress);
    };
  }, []);

  return (
    <div
      id="modal-container"
      onClick={handleClickOutside}
      className="absolute opacity-100 z-[100] h-full w-full pointer-events-auto backdrop-blur-sm flex items-center justify-center p-8"
    >
      <div className="relative overflow-y-scroll data-[state=open]:animate-overlayShow bg-[url('/grid.svg')] data-[state=open]:animate-contentShow border bg-black bg-opacity-85 shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none shadow-widget max-h-[85vh] w-[90vw] max-w-[450px] rounded-lg flex flex-col items-center justify-start gap-8 p-4">
        <div className="absolute top-4 right-4 z-[110]">
          <button
            type="button"
            tabIndex={0}
            onClick={handleClose}
            className={'pointer-events-auto btn btn-sm border-0 btn-circle'}
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="h-full w-full">
          <h1 className="text-slate-100 m-0 text-[17px] font-medium">Edit</h1>
          <p className="text-slate-100 mt-[10px] mb-5 text-[15px] leading-normal">
            Make changes to your node here.
          </p>
          <NodeDetailsForm
            nodeData={selectedNodeData}
            updateNodeData={updateWorkflowNodeData}
          />
        </div>
      </div>
    </div>
  );
}
